// No React or feature imports: caches register here without depending on auth.
const resets = new Set();
let generation = 0;
export const registerSessionReset = reset => { resets.add(reset); return () => resets.delete(reset); };
// Storage can be unavailable (blocked/private modes, or after a test page is torn
// down). Late callbacks must then see a stale session, never throw.
function storedToken() {
  try { return typeof localStorage === 'undefined' ? null : localStorage.getItem('accessToken') || ''; } catch { return null; }
}
export const sessionTicket = () => { const token = storedToken(); return token === null ? `${generation}:unavailable:${Math.random()}` : `${generation}:${token}`; };
export const sessionIsCurrent = ticket => ticket === sessionTicket();
export function assertSessionCurrent(ticket) {
  if (!sessionIsCurrent(ticket)) throw Object.assign(new Error('Your session changed. Sign in again before continuing.'), { code: 'SESSION_CHANGED' });
}
export function resetSessionData() {
  generation++;
  resets.forEach(reset => { try { Promise.resolve(reset()).catch(() => {}); } catch { /* Other owners must still be reset. */ } });
}

// Keep user partitions (drafts, frozen commands, personal settings); remove only
// obsolete/unscoped UI choices. Never clear the whole origin's storage.
export function clearUnscopedSessionStorage() {
  for (const key of Object.keys(localStorage)) {
    if ((key.startsWith('qv4_') && !key.startsWith('qv4_export_columns_'))
      || ['wati_notifications_enabled', 'wati_qv4_sound_enabled', 'gallery_watermark_enabled', 'srm-local-owner'].includes(key)) localStorage.removeItem(key);
  }
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith('uzdpart360:device-location:startup:')) sessionStorage.removeItem(key);
  }
}
